module.exports = __webpack_public_path__ + "img/service_3.c9a27ff1.png";